"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Crypto = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ui = require("../../ui");
var _Truncate = require("../Truncate");
var _Item = require("./Item");
var _ticker = require("../../ticker");
var _cryptoConstraints = require("@ppay/crypto-constraints");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var IconStyled = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-right: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Crypto = function Crypto(_ref) {
  var transaction = _ref.transaction;
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransaction'),
    t = _useTranslation.t;
  if (!transaction.blockchain) {
    return null;
  }
  var blockchainExplorer = _cryptoConstraints.BlockchainExplorer[transaction.blockchain];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, transaction.hash && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.hash')
  }, /*#__PURE__*/_react.default.createElement(_ui.Link, {
    href: blockchainExplorer.link + transaction.hash,
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Truncate.Truncate, null, transaction.hash))), !!transaction.from && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.from')
  }, /*#__PURE__*/_react.default.createElement(_ui.Link, {
    href: blockchainExplorer.address + transaction.from,
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Truncate.Truncate, null, transaction.from))), transaction.to && /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.to')
  }, /*#__PURE__*/_react.default.createElement(_ui.Link, {
    href: blockchainExplorer.address + transaction.to,
    target: "_blank"
  }, /*#__PURE__*/_react.default.createElement(_Truncate.Truncate, null, transaction.to))), /*#__PURE__*/_react.default.createElement(_Item.Item, {
    label: t('receipt.blockchain')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(IconStyled, null, /*#__PURE__*/_react.default.createElement(_ticker.TickerIcon, {
    ticker: blockchainExplorer.ticker,
    size: 16
  })), blockchainExplorer.network)));
};
exports.Crypto = Crypto;